
import { Base } from '../base-component';
import './article-combo.component.scss';

export class ArticleCombo extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}
}


// WEBPACK FOOTER //
// ./components/article-combo/article-combo.component.ts